import './ExcellentPower.scss';
import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { useMediaQuery } from 'usehooks-ts';

export default function ExcellentPower({ fields }) {
  const { titleRichText, image, mobileImage } = fields;
  const isMobile = useMediaQuery('(max-width: 480px)');
  let backgroundStyle = {
    backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 54.42%, #000000 100%), url(${image?.value?.src})`,
  };
  if (isMobile) {
    backgroundStyle = {
      backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 54.42%, #000000 100%), url(${mobileImage?.value?.src})`,
    };
  }

  return (
    <div className={'excellent-power'}>
      <div style={backgroundStyle} className={'container wrapper'} data-aos="fade-up">
        <div className={'inner'}>
          <div data-aos="fade-up" data-aos-offset={200}>
            <div className={'title'}>
              <RichText field={titleRichText} />
            </div>
            <div className={'text'}>
              <RichText field={fields.descRichText} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
